import * as React from "react";
import { Button, ListItem } from "@material-ui/core";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import { ContactTheContactDialog } from "./ContactTheContactDialog";
import { Contact } from "../../generated/nest-graphql";
import { ContactDialog } from "../Contacts/ContactDialog";
import { useHistory } from "react-router-dom";
import { useToggle } from "../../hooks/useToggle";
import { withReturnJob } from "../../hooks/useInAppHistory";

const ContactListItemInternals: React.FC<{
  primary: string;
  contactId: string;
  jobId?: string | null;
  secondary: string;
  onClick: () => void;
}> = ({ onClick, primary, secondary, contactId, jobId }) => {
  const { push } = useHistory();
  return (
    <ListItem divider button onClick={() => push(withReturnJob(`/contacts/${contactId}`, jobId))}>
      <ListItemText primary={primary} secondary={secondary} />
      <ListItemSecondaryAction>
        <Button color={"primary"} variant={"outlined"} onClick={onClick}>
          {"Contact"}
        </Button>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

/** `jobId`: the job this is shown on, which the contact page falls back to when opened on its own. */
export const ContactListItem: React.FC<{ contact: Contact; jobId?: string | null }> = ({ contact, jobId }) => {
  const { fullName, email, id } = contact;
  const [open, , toggleDialog] = useToggle();
  return (
    <>
      <ContactListItemInternals
        primary={fullName}
        secondary={email}
        onClick={toggleDialog}
        contactId={id}
        jobId={jobId}
      />
      <ContactTheContactDialog open={open} closeDialog={toggleDialog} contact={contact} />
    </>
  );
};

export const ContactListItemDialog: React.FC<{ contact: Contact }> = ({ contact }) => {
  const { id } = contact;
  const { fullName, email } = contact;

  const [contactDialogOpen, , toggleContactDialog] = useToggle();
  const [contactOpen, , toggleDialog] = useToggle();
  return (
    <>
      <ListItem divider button onClick={toggleDialog}>
        <ListItemText primary={fullName} secondary={email} />
        <ListItemSecondaryAction>
          <Button color={"primary"} variant={"outlined"} onClick={toggleContactDialog}>
            {"Contact"}
          </Button>
        </ListItemSecondaryAction>
      </ListItem>
      <ContactTheContactDialog open={contactDialogOpen} closeDialog={toggleContactDialog} contact={contact} />
      <ContactDialog contactId={id} open={contactOpen} closeHandler={toggleDialog} />
    </>
  );
};
